export enum InventoryItemUnit {
  PIECES = "PIECES",
  GRAMS = "GRAMS",
  KILOGRAMS = "KILOGRAMS",
  MILLIGRAMS = "MILLIGRAMS",
  MILLILITERS = "MILLILITERS",
  LITERS = "LITERS",
  AMPULES = "AMPULES",
}
